import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetOrganizationsFilteredQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.Organizations_Bool_Exp>;
}>;


export type GetOrganizationsFilteredQuery = { __typename?: 'query_root', organizations: Array<{ __typename?: 'organizations', id: any, name: string, contact_name?: string | null, email?: string | null, type?: string | null, organizationImageURL?: string | null, workspace_id: any, created_at?: any | null, updated_at?: any | null, org_properties: Array<{ __typename?: 'properties', id: any, name: string, address?: string | null, address_id?: any | null, premium?: boolean | null, tier_status?: string | null, standardized_address?: { __typename?: 'addresses', id: any, street_1: string, street_2?: string | null, city: string, state: string, postal_code: string, country: string } | null, property_users: Array<{ __typename?: 'user_properties', user?: { __typename?: 'users', id: string, first_name: string, last_name: string, role?: string | null, email: string, profile_photo?: string | null } | null }>, property_users_aggregate: { __typename?: 'user_properties_aggregate', aggregate?: { __typename?: 'user_properties_aggregate_fields', count: number } | null } }>, org_properties_aggregate: { __typename?: 'properties_aggregate', aggregate?: { __typename?: 'properties_aggregate_fields', count: number } | null }, org_users: Array<{ __typename?: 'users', id: string, first_name: string, email: string, role?: string | null, is_admin?: boolean | null, last_name: string }> }> };


export const GetOrganizationsFilteredDocument = gql`
    query getOrganizationsFiltered($where: organizations_bool_exp) {
  organizations(where: $where, order_by: {name: asc}) {
    id
    name
    contact_name
    email
    type
    organizationImageURL
    workspace_id
    created_at
    updated_at
    org_properties {
      id
      name
      address
      address_id
      standardized_address {
        id
        street_1
        street_2
        city
        state
        postal_code
        country
      }
      premium
      tier_status
      property_users {
        user {
          id
          first_name
          last_name
          role
          email
          profile_photo
        }
      }
      property_users_aggregate {
        aggregate {
          count(distinct: true)
        }
      }
    }
    org_properties_aggregate {
      aggregate {
        count(distinct: true)
      }
    }
    org_users {
      id
      first_name
      email
      role
      is_admin
      last_name
    }
  }
}
    `;

/**
 * __useGetOrganizationsFilteredQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsFilteredQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsFilteredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsFilteredQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetOrganizationsFilteredQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationsFilteredQuery, GetOrganizationsFilteredQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationsFilteredQuery, GetOrganizationsFilteredQueryVariables>(GetOrganizationsFilteredDocument, options);
      }
export function useGetOrganizationsFilteredLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationsFilteredQuery, GetOrganizationsFilteredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationsFilteredQuery, GetOrganizationsFilteredQueryVariables>(GetOrganizationsFilteredDocument, options);
        }
export function useGetOrganizationsFilteredSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationsFilteredQuery, GetOrganizationsFilteredQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationsFilteredQuery, GetOrganizationsFilteredQueryVariables>(GetOrganizationsFilteredDocument, options);
        }
export type GetOrganizationsFilteredQueryHookResult = ReturnType<typeof useGetOrganizationsFilteredQuery>;
export type GetOrganizationsFilteredLazyQueryHookResult = ReturnType<typeof useGetOrganizationsFilteredLazyQuery>;
export type GetOrganizationsFilteredSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationsFilteredSuspenseQuery>;
export type GetOrganizationsFilteredQueryResult = Apollo.QueryResult<GetOrganizationsFilteredQuery, GetOrganizationsFilteredQueryVariables>;